import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import './Login.css';
import { AuthContext } from '../contexts/AuthContext';
import GoogleButton from './GoogleButton';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, user } = useContext(AuthContext);
  const [componentId] = useState(Math.random().toString(36).substring(2, 9));

  console.log(`[Login:${componentId}] Component mounted with user:`, user);

  // Check if user is already logged in
  useEffect(() => {
    if (user) {
      console.log(`[Login:${componentId}] User already logged in, redirecting to home`);
      navigate('/');
    }
  }, [user, navigate, componentId]);

  // Check for error parameter in URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const errorParam = params.get('error');
    if (errorParam) {
      console.error(`[Login:${componentId}] Login error from URL:`, errorParam);
      setError('Authentication failed. Please try again.');
    }
  }, [location, componentId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log(`[Login:${componentId}] Attempting login with email/password`);
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/login`, { email, password });
      const { token, ...userData } = response.data;
      console.log(`[Login:${componentId}] Login successful:`, userData);

      // Store token in localStorage
      localStorage.setItem('token', token);
      console.log(`[Login:${componentId}] Token stored in localStorage`);

      // Update user state
      setUser(userData);
      console.log(`[Login:${componentId}] User state updated`);

      // Navigate to home page
      navigate('/');
    } catch (error) {
      console.error(`[Login:${componentId}] Login error:`, error);
      setError(error.response?.data?.error || 'Login failed');
    }
  };

  const handleGoogleLogin = () => {
    // Use the correct API URL based on the environment
    const apiUrl = process.env.NODE_ENV === 'production'
      ? 'https://www.theotherside.media'
      : 'http://localhost:5000';

    const authUrl = `${apiUrl}/auth/google`;
    console.log(`[Login:${componentId}] Redirecting to Google auth URL:`, authUrl);
    window.location.href = authUrl;
  };

  return (
    <div className="container mt-5 login-container">
      <h2>Login</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <GoogleButton onClick={handleGoogleLogin} />

      <div className="divider">
        <span>or</span>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="loginEmail">Email address</label>
          <input
            type="email"
            className="form-control"
            id="loginEmail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="loginPassword">Password</label>
          <input
            type="password"
            className="form-control"
            id="loginPassword"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Login</button>
      </form>
    </div>
  );
};

export default Login;
